import {
  Component,
  OnInit
} from '@angular/core';
import {
  ActivatedRoute
} from '@angular/router';
import {
  AdminData
} from '../../models/AdminData.model';
import {
  LicenseDataService
} from '../../services/LicenseData.service';
import {
  HttpErrorResponse
} from '@angular/common/http';
import {
  AdminUserData
} from '../../models/AdminUserData.model';
import {
  Location
} from '@angular/common';
import {
  ProductPaymentItemModel
} from '../../models/ProductPaymentItem.model';
import {
  PaymentsItemModel
} from '../../models/PaymentsItem.model';
import {
  PaymentParentModel
} from '../../models/PaymentParent.model';
import {
  EProductType
} from '../../EProductType.enum';
import {
  LicensesFinalPaymentModal
} from '../../models/LicensesFinalPayment.model';
import {
  ProductsDetail1
} from '../../models/ProductsDetail.model';
import {
  PaymentMethod
} from '../../PaymentMethod.enum';
import {
  ProductPaymentDetailsModal
} from '../../models/ProductPaymentDetails.model';
import {
  InvoiceInformationModal
} from '../../models/InvoiceInformation.model';
import {
  AlertMessages,
  AlertType
} from '../../../../core/AlertMessages';
import {
  UpgradeProductModel
} from './UpgradeProductModel';
import {
  HaAdminFilterTypeEnum
} from './HaAdminFilterTypeEnum';
import {
  LedgerModel
} from './LedgerModel';
import {
  SaPaymentModel
} from '../../models/SaPayment.model';
import {
  ErrorModel
} from '../../../../shared/models/Error.model';
import {
  setTime
} from '@syncfusion/ej2-schedule';

declare var $: any;
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  adminId: string;
  adminDetails: AdminData;
  adminList: AdminData[];
  adminUsers: AdminUserData[];
  abc: PaymentMethod;
  qrValue: string;
  totalLicenses;
  showHaData: boolean = false;
  searchTerm: string = '';
  editSub: boolean = true;
  // checkPaymentModal: number = 1;
  activeElement2: PaymentMethod;
  chequeSelected: boolean = true;
  userLogs;
  newLicenes: AdminUserData[];
  memoryOccupied;
  searchFilterVal: string = "";
  totalmemory;
  currentPage: number;
  counterForLoader = 1;
  showOverlay: boolean;
  showAdminListsLoad: boolean;
  showAdminInfoListLoad: boolean;
  element: HTMLElement;
  // newWin;
  // bankName: string = "";
  // nameOnChq: string = "";
  // chequeNo: string = "";
  // bankAddress: string = "";
  transactionHistories: LedgerModel[];
  // showBack: boolean = false;
  routingPath: string = "";
  linkPath: string = "";
  // pendingPayment: any;
  filterLicense: number = 0;
  licenseFilterSelected: boolean = false;
  showBackMain: boolean = false;
  showBackSingle: boolean = false;
  today;
  todayDate;
  totalCount: number = 0;
  paymentMethodSelected: PaymentMethod;
  LicensesReturnModal: LicensesFinalPaymentModal;
  // payment modal
  newModelPayment: PaymentsItemModel[];
  oldModelPayment: PaymentsItemModel[];
  parentPaymentModal: PaymentParentModel;
  singleProductPayment: ProductPaymentItemModel;
  newModelLicenses: PaymentsItemModel;
  oldModelLicenses: PaymentsItemModel;
  // firstTimeLicenseCost;
  // firstTimeValidityCost;
  // firstTimeSubtotalCost;
  // firstTimeServiceCost;
  // firstTimeTaxCost;
  // firstTimeDiscountCost;
  // otherTimeLicenseCost;
  // otherTimeValidityCost;
  // otherTimeSubtotalCost;
  // otherTimeServiceCost;
  // otherTimeTaxCost;
  // otherTimeDiscountCost;
  accessTypeMain;
  // oldLicenseQty: number = 0;
  // oldValidityDaysString: string = "";
  // oldValidityDaysNumber: number = 0;
  // newLicenseQty: number = 0;
  // newValidityDaysString: string = "";
  // newValidityDaysNumber: number = 0;
  paymentModuleStatus: boolean = false;
  // oldValidateDate;
  // newValidateDate;
  // oldValidateDateToDisplay;
  // newValidateDateToDisplay;
  newLicCount: number = 0;
  // firstCurrentDate;
  // firstMinDate;
  // firstValidDaysCalculated;
  // otherCurrentDate;
  // otherMinDate;
  // otherValidDaysCalculated;
  // servicesAdded: any[] = [];
  // licensesAdded: any[] = [];
  // validityAdded: any[] = [];
  subTotalAmount: number = 0;
  services: ProductsDetail1[];
  finalPaymentReturnModalDisplay: LicensesFinalPaymentModal;
  licenseData: PaymentsItemModel = new PaymentsItemModel();
  totalLicensesCount: number = 0
  // masterCost: number = 0;
  // totalPayableAmount: number = 0;
  daysDifference: number = 0;
  expireOnDate;
  // expireDateShow;
  taxAmount: number = 0;
  totalAmountI: number = 0;
  discountAmountVal: number = 0;
  masterCostt: number = 0;
  masterType;
  currentDate;
  expireOldDate;
  oldServicesSubscribed;
  showOverlayPayment: boolean = false;
  finalPaymentDetails: ProductPaymentDetailsModal;
  curdateee;
  curdateee1;
  curdateee2;
  curdateee3;
  secondTimePaymentValidity: number = 0;
  invoiceDetailHa: InvoiceInformationModal[];
  invoiceProductDetails: ProductPaymentItemModel[];
  invoiceDetailsGetHtml;
  demoLicenseCurrentDate;
  upgradeModelShow: boolean = false;
  upgradeProducts: UpgradeProductModel[];
  updationProduct: PaymentsItemModel = null;
  searchTermIs = '';
  filterPipeIs = 0;
  mainViewError = new ErrorModel();
  searchError = new ErrorModel();
  licenseListError = new ErrorModel();
  logsError = new ErrorModel();
  transactionError = new ErrorModel();
  invoiceError = new ErrorModel();
  filterArray: any[];
  // new payment variables
  extendLicenseQty: string = '1';
  oneLicenseAmount: number = 199;
  calculatedLicenseAmount: number;
  actualLicenseAmount: number = 0;
  pendingLicenseDays: number;
  taxOnLicenseActualAmount: number = 0;
  licenseTotalAmount: number;

  licenseEdit: boolean;
  showChequeDetail: boolean = false;
  chequeNumberNew: string = '';
  licenseModelNew: any;
  processLicenseRequest: boolean = false;
  selectedPaymentMethod: string = '2';
  selectedLicenseType: number;
  validityModelNew: any;
  extendValidityDays: number = 0;
  actualValidityAmount: number = 0;
  calculatedValidityAmount: number = 0;
  calculatedValidityTax: number = 0;
  roundedValidityAmount: number = 0;
  // roundedValidityTax: number = 0;
  processValidityRequest: boolean = false;
  saveCurrentExpiryDate: string;
  saleItemsArray: any = [];
  firstPaymentStatus:boolean = false;
  firstPaymentModel: any;
  processMasterRequest:boolean = false;
  firstPaymentTotal: any;
  processExtensionRequest: boolean = false;
  upgradeLicenseModelNew: any ;
  amountForUpgrade: number;
  demoToRegActualAmount: number;
  showExtensionPaymentMethod : boolean = false;
  roundOffValueDemoToReg: string = '';
  roundOffValueValidity: string = '';
  // roundOffValueValidityTax: string = '';
  // roundOffValueMaster:string;
  totalLicenseAmountCalculated:number = 0;
  roundOffValueLicense:string = '';
  showAdminListsLoadOne:boolean = false;


  constructor(private _service: LicenseDataService, private _route: ActivatedRoute, private location: Location) {
    this.filterArray = [{
        id: 0,
        name: 'All'
      },
      {
        id: 1,
        name: 'Blocked'
      },
      {
        id: 2,
        name: 'Expired'
      },
      {
        id: 3,
        name: 'Active'
      },
      {
        id: 4,
        name: 'Inactive'
      }

    ]

  }

  ngOnInit() {
    this.licenseFilterSelected = false;
    this.paymentModuleStatus = false;
    this.curdateee1 = new Date().getDate();
    this.curdateee2 = new Date().getMonth() + 1;
    this.curdateee3 = new Date().getFullYear();
    this.curdateee = this.curdateee3 + "-" + this.curdateee2 + "-" + this.curdateee1;
    this.transactionHistories = [];
    this.activeElement2 = PaymentMethod.CHEQUE;
    this.currentDate = new Date().toISOString().split("T")[0];
    this.demoLicenseCurrentDate = new Date().toISOString().split("T")[0];
    this.totalCount = 0;
    this.showOverlay = true;
    this.currentPage = 1;
    this.routingPath = "";
    this.filterLicense = 0;


    this._route.queryParams.subscribe(params => {
      this.filterLicense = params['filterLicense'], this.routingPath = params['routingPath'], this.linkPath = params['linkpath']
    });
    if (this.routingPath == null || this.routingPath == undefined) {
      this.routingPath = "";
      this.showBackMain = false;
    } else {
      this.showBackMain = true;
    }
    if (this.linkPath == null || this.linkPath == undefined) {
      this.linkPath = "";
      this.showBackSingle = false;
    } else {
      this.showBackSingle = true;
    }
    if (this.filterLicense == undefined || this.filterLicense == null) {
      this.filterLicense = 0;
    }

    this.getAdmins();

    this._route.queryParams.subscribe(params => {
      this.adminId = params['Ad_Id'];
      this.selectedLicenseType = params['lType'];
      if (this.adminId != undefined) {
        setTimeout(() => {
          this.changeAdmin(this.adminId);
        }, 1000);
      }
    });

  }


  getAdmins() {
    this.showOverlay = true;
    this.mainViewError.display = false;
    this._service.getAdmins(1, "", this.filterLicense).subscribe(
      (data) => {

        if (this.counterForLoader == 1) {
          this.counterForLoader = this.counterForLoader + 1;
        } else {
          this.showAdminListsLoad = true;
        }

        this.adminList = data["AdminLicenseDetails"];
        this.totalCount = data["HaAdminCount"]
        this.showAdminListsLoad = false;
        if (this.adminId == null || this.adminId == '' || this.adminId == undefined) {
          if (this.adminList[0] !== undefined && this.adminList[0] !== null) {
            this.adminId = this.adminList[0].id;

            const index = this.adminList.findIndex(a => a.id == this.adminId);

            this.adminList[index].backgroundColor = "#f2f2f2";
            this.showHaData = false;
            // this.upgradeModel(this.adminId);

          }

        } else {
          const indx = this.adminList.findIndex(a => a.id == this.adminId);
          if (indx != -1) {
            this.adminList[indx].backgroundColor = "#f2f2f2";
          }
          this.showHaData = true;
        }

      },
      (error) => {
        this.mainViewError.error = error;
        this.mainViewError.display = true;
      }).add(() => {
      this.showOverlay = false;
    });

  }

  getAllInvoicesDetailsOfHa(adminId) {
    this.invoiceDetailHa = [];
    this.showAdminInfoListLoad = true;
    this.invoiceError.display = false;
    this._service.getAllInvoicesDetailsOfHa(adminId).subscribe(
      (data: InvoiceInformationModal[]) => {
        this.invoiceDetailHa = data;
        this.invoiceDetailHa.forEach(element => {
          element.dateDisplay = new Date(element.dateShow).toISOString().split("T")[0];
        });
      },
      (error) => {
        this.invoiceError.error = error;
        this.invoiceError.display = true;

      }).add(() => {
      this.showAdminInfoListLoad = false;
    });
  }

  getSaParentPaymentModal(adminId) {
    this.showAdminInfoListLoad = true;
    this.parentPaymentModal = new PaymentParentModel();
    this._service.getSaParentPaymentModal(adminId).subscribe(
      (data: PaymentParentModel) => {
        this.parentPaymentModal = data;
        if (this.parentPaymentModal.currentStateModal.expireDate == null || this.parentPaymentModal.currentStateModal.expireDate == undefined || this.parentPaymentModal.currentStateModal.expireDate == 0) {
          var expiry = new Date();
          expiry.setDate(expiry.getDate() + 30);
          this.expireOldDate = new Date(expiry).toISOString().split("T")[0];
        } else {
          this.expireOldDate = new Date(this.parentPaymentModal.currentStateModal.expireDate).toISOString().split("T")[0];
        }
        this.paymentMethodSelected = PaymentMethod.CHEQUE;
        this.activeElement2 = PaymentMethod.CHEQUE;
        this.setAllServices();
        this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
        this.getOnInitExpireDate();
        this.calculatePendingDays();
        // this.getLicenseRequestNew();
        // this.getValidityData();
      }).add(() => {
      this.showAdminInfoListLoad = false;
    });

  }

  getUsersWithMemory(adminId) {
    this.licenseListError.display = false;
    this._service.getUsersWithMemory(adminId).subscribe(
      (data) => {
        this.newLicenes = data["users"] as AdminUserData[];
        this.adminUsers = this.newLicenes;
        this.memoryOccupied = data["totalHaMemory"];
      },
      (error) => {
        this.licenseListError.error = error;
        this.licenseListError.display = true;
      });

  }

  getPendingSalesOfHa(adminId) {
    this.transactionError.display = false;
    this.transactionHistories = [];

    this._service.getPendingSalesOfHa(adminId).subscribe(
      (data) => {
        this.transactionHistories = data["Ledger"];
      },
      (error) => {
        this.transactionError.error = error;
        this.transactionError.display = true;
      });
  }

  setAllServices() {

    var allServices = this.parentPaymentModal.allProducts.filter(i => i.productType == EProductType.SERVICES);
    var oldServices = this.parentPaymentModal.oldModel.filter(i => i.productType == EProductType.SERVICES);
    var newServices = this.parentPaymentModal.newModel.filter(i => i.productType == EProductType.SERVICES);
    this.oldServicesSubscribed = oldServices;
    oldServices.forEach(element => {
      allServices.forEach(element1 => {

        if (element.productId == element1.productId) {
          var index = allServices.indexOf(element1);
          allServices.splice(index, 1);
        }
      });
    });

    if (newServices.length > 0) {
      newServices.forEach(element => {
        allServices.forEach(element1 => {
          if (element.productId == element1.productId) {
            element1.isChecked = true;
          }
        });
      });
    }

    this.services = allServices;

  }

  // checkAmountControlLabel(amount) {

  //   if (amount == null || amount == undefined || amount < 0) {
  //     this.totalAmountI = 0;
  //   } else {
  //     this.totalAmountI = amount;
  //   }

  //   this.subTotalAmount = ((this.totalAmountI * 100) / (100 + 6.25));
  //   this.subTotalAmount = parseFloat(this.subTotalAmount.toFixed(2));
  //   this.taxAmount = (this.subTotalAmount * 6.25) / 100;
  //   this.taxAmount = parseFloat(this.taxAmount.toFixed(2));
  //   if (this.finalPaymentReturnModalDisplay.totalAmount > amount) {
  //     this.discountAmountVal = this.finalPaymentReturnModalDisplay.totalAmount - amount;
  //     this.discountAmountVal = parseFloat(this.discountAmountVal.toFixed(2));
  //   } else {
  //     this.discountAmountVal = 0;
  //     this.discountAmountVal = parseFloat(this.discountAmountVal.toFixed(2));
  //   }
  // }

  onScrollGetAdmins(searchText: string, filterType, infiniteScrollDistance, infiniteScrollThrottle) {
    this.showAdminListsLoad = true;
    this.currentPage = this.currentPage + 1;
    this.filterLicense = filterType;
    this._service.getAdmins(this.currentPage, searchText.trim(), this.filterLicense).subscribe(
      (data) => {
        const adminsss: AdminData[] = data["AdminLicenseDetails"];
        if (adminsss != undefined) {
          adminsss.forEach(i => {
            this.adminList.push(i)
          })
        }
      },
      (error) => {
        this.currentPage = this.currentPage - 1;
        AlertMessages.Show('Failed', 'Could not load!', AlertType.Error);

      }).add(() => {
      this.showAdminListsLoad = false;
    })
  }

  searchUser(searchText: string, filterType) {
    this.searchError.display = false;
    this.showAdminListsLoad = true;
    this.searchTermIs = searchText;
    this.filterPipeIs = filterType;
    this.currentPage = 1;
    this.filterLicense = filterType;

    this._service.getAdmins(1, searchText, this.filterLicense).subscribe(
      (data) => {
        this.adminList = data["AdminLicenseDetails"];
      },
      (error) => {
        this.searchError.error = error;
        this.searchError.display = true;

      }).add(() => {
      this.showAdminListsLoad = false;

    })
  }

  getUserLogs(saId) {
    this.logsError.display = false;
    this._service.getUserLogs(saId).subscribe(
      (data) => {
        this.userLogs = data;
        this.userLogs.forEach(i => {
          const logT = new Date(i.logTime);
          i.LogTime = logT.getHours() + ':' + logT.getMinutes();
        })
      },
      (error) => {
        this.logsError.error = error;
        this.logsError.display = true;
      })
  }

  changeAdmin(adminId) {
    this.adminId = adminId;
    this.licenseFilterSelected = false;
    this.chequeSelected = true;
    this.activeElement2 = 3;
    this.paymentModuleStatus = false;
    this.showHaData = true;
    this.showAdminInfoListLoad = true;
    // this.upgradeModel(adminId);
    this.getFirstPaymentStatus();

    this._service.getSingleAdminDetails(adminId).subscribe(
      (data: AdminData) => {
        this.adminDetails = data;

        if (this.adminList !== undefined && this.adminList !== null) {
          for (const v of this.adminList) {
            v.backgroundColor = "white";
          }

        }

        this.adminUsers = [];
        this.userLogs = [];
        this.qrValue = this.adminDetails.licenseNo;
    // this.getFirstPaymentStatus();

        this.getUsersWithMemory(adminId);
        this.getUserLogs(adminId);
        this.parentPaymentModal = new PaymentParentModel();
        this.getSaParentPaymentModal(adminId);
        this.invoiceDetailHa = [];
        this.getAllInvoicesDetailsOfHa(adminId);
        this.getPendingSalesOfHa(adminId);
        // this.showHaData = true;

        if (this.adminList != undefined) {
          this.adminList[this.adminList.findIndex(admin => admin.id == adminId)].backgroundColor = 'gold';
        }
      },
      (error) => {
        AlertMessages.Show('Failed', 'could not load', AlertType.Error);
        this.showHaData = false;
        this.showOverlay = false;

      }).add(() => {
      this.showAdminInfoListLoad = false;
    })
  }


  blockLicense(data) {
    this._service.blockActiveLicense(data.id).subscribe(
      (message) => {
        this.adminUsers[data.index].adminIsDeleted = true;
        this.getUserLogs(this.adminId);
        AlertMessages.Show("Blocked", this.adminUsers[data.index].licenseNo + ' is Blocked', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not block!', AlertType.Error);
      })
  }

  activeLicense(data) {
    this._service.blockActiveLicense(data.id).subscribe(
      (message) => {

        this.adminUsers[data.index].adminIsDeleted = false;
        this.getUserLogs(this.adminId);
        AlertMessages.Show("Activated", this.adminUsers[data.index].licenseNo + ' is Activated', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not activate!', AlertType.Error)
      })
  }

  scrollToElement($element): void {
    $element.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    });
  }

  adminBlockActive(event) {

    this._service.blockActiveAdmin(this.adminId).subscribe((abc) => {
        const index = this.adminList.findIndex(admin => admin.id == this.adminId);
        this.adminList[index].isLock = event.target.checked;
        this.adminDetails.isLock = event.target.checked;
        AlertMessages.Show((event.target.checked == true) ? 'BLOCKED' : 'ACTIVATED', this.adminList[index].name + ((event.target.checked == true) ? ' is Blocked' : ' is Active'), (event.target.checked == true) ? AlertType.Error : AlertType.Success);

      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not activate!', AlertType.Error);
      });
  }

  stopProp(event) {
    event.stopPropagation();
  }

  adminBlockActiveCard(eventData) {
    this.adminDetails = eventData.admin;
    this._service.blockActiveAdmin(eventData.id).subscribe((abc) => {
        const index = this.adminList.findIndex(admin => admin.id == eventData.id);
        this.adminList[index].isLock = eventData.evt.target.checked;
        this.adminDetails.isLock = eventData.evt.target.checked;
        AlertMessages.Show((eventData.evt.target.checked == true) ? 'BLOCKED' : 'ACTIVATED', this.adminList[index].name + ((eventData.evt.target.checked == true) ? ' is Blocked' : ' is Active'), (eventData.evt.target.checked == true) ? AlertType.Error : AlertType.Success);

      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not activate!', AlertType.Error);
      });
  }

  onPrint() {
    let printContents, popupWin;
    printContents = document.getElementById('printTable').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (!!popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>

          <style>
          table {
           font-family: arial, sans-serif;
           border-collapse: collapse;
           width: 100%;
         }

         td, th {
           border: 1px solid #dddddd;
           text-align: left;
           padding: 8px;
         }

         tr:nth-child(even) {
           background-color: #dddddd;
         }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
      popupWin.document.close();
    } else {
      AlertMessages.Show('Print Info', 'Make sure pop-up is allowed', AlertType.Warning);
    }
  }


  onPrintTransaction() {
    let printContents, popupWin;
    printContents = document.getElementById('printhistoryTable').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (!!popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
       <html>
         <head>

           <style>
           table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
           </style>
         </head>
     <body onload="window.print();window.close()">${printContents}</body>
       </html>`);
      popupWin.document.close();

    } else {
      AlertMessages.Show('Print Info', 'Make sure pop-up is allowed', AlertType.Warning);
    }
  }

  filterUsers(type) {
    this.licenseFilterSelected = true;
    this.currentPage = 1;
    this.showAdminInfoListLoad = true;
    if (type == HaAdminFilterTypeEnum.all) {
      this.adminUsers = this.newLicenes;
      this.showAdminInfoListLoad = false;
    } else if (type == HaAdminFilterTypeEnum.active) {
      this.adminUsers = this.newLicenes.filter((license) => license.eaIsUsed == true && license.sahlIsLock == false && license.adminIsDeleted == false);
      this.showAdminInfoListLoad = false;
    } else if (type == HaAdminFilterTypeEnum.blocked) {
      this.adminUsers = this.newLicenes.filter((license) => license.adminIsDeleted == true);
      this.showAdminInfoListLoad = false;
    } else if (type == HaAdminFilterTypeEnum.inactive) {
      this.adminUsers = this.newLicenes.filter((license) => license.eaIsUsed == false && license.adminIsDeleted == false);
      this.showAdminInfoListLoad = false;
    }
    this.showAdminInfoListLoad = false;
  }

  goBackLink() {
    // $('#masterModal').modal('hide');
    $('.modal-backdrop').remove();
    this.location.back();
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode == 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  // increementLicenses() {
  //   var newModel: PaymentsItemModel[] = this.parentPaymentModal.newModel;
  //   var oldModel: PaymentsItemModel[] = this.parentPaymentModal.oldModel;

  //   if (newModel.length < 1) {
  //     this.updateLicenseCount(1, newModel);
  //   } else {
  //     if (newModel.filter(model => model.productType == EProductType.LICENSES).length < 1) {
  //       this.updateLicenseCount(1, newModel);
  //     } else {
  //       this.updateLicenseCount(0, newModel);
  //     }
  //   }
  // }

  //1 For New and 0 For Old
  // updateLicenseCount(licenseType: number, newModel: PaymentsItemModel[]) {
  //   if (licenseType == 1) {
  //     var GETLICENSES: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.LICENSES)[0];

  //     var LICENSES: PaymentsItemModel = this.getDefaultPaymentsItemModel1(EProductType.LICENSES);
  //     if (LICENSES != null && LICENSES != undefined) {
  //       if (LICENSES.productId != null && LICENSES.productId != undefined && LICENSES.productId != "") {

  //         this.parentPaymentModal.newModel.push(LICENSES);
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty = LICENSES.productQty + 1;
  //         this.newModelLicenses = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0];
  //         this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  //         var existingProductQty: number = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty;
  //         var otherchargess: number = parseFloat(((this.finalPaymentReturnModalDisplay.licenseAmount) - (LICENSES.productAmount * existingProductQty)).toString());
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].otherCharges = parseFloat(otherchargess.toFixed(2));

  //       } else {
  //         LICENSES = this.getDefaultPaymentsItemModel();
  //         AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);

  //       }

  //     } else {
  //       LICENSES = this.getDefaultPaymentsItemModel();
  //       AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);
  //     }
  //   } else {
  //     var GETLICENSES: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.LICENSES)[0];
  //     var LICENSES: PaymentsItemModel = GETLICENSES == undefined || GETLICENSES == null ? this.getDefaultPaymentsItemModel1(EProductType.LICENSES) : GETLICENSES;
  //     if (LICENSES != null && LICENSES != undefined) {
  //       if (LICENSES.productId != null && LICENSES.productId != undefined && LICENSES.productId != "") {
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty = LICENSES.productQty + 1;
  //         this.newModelLicenses = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0];
  //         this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  //         var ExistingProductQty: number = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty;
  //         var otherchargess: number = parseFloat(((this.finalPaymentReturnModalDisplay.licenseAmount) - (LICENSES.productAmount * ExistingProductQty)).toString());
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].otherCharges = parseFloat(otherchargess.toFixed(2));
  //       } else {
  //         LICENSES = this.getDefaultPaymentsItemModel();
  //         AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);
  //       }

  //     } else {
  //       LICENSES = this.getDefaultPaymentsItemModel();
  //       AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);

  //     }
  //   }
  // }

  // decreementLicenses() {
  //   var newModel: PaymentsItemModel[] = this.parentPaymentModal.newModel;
  //   var oldModel: PaymentsItemModel[] = this.parentPaymentModal.oldModel;
  //   var GETLICENSES: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.LICENSES)[0];
  //   var LICENSES: PaymentsItemModel = GETLICENSES == undefined || GETLICENSES == null ? this.getDefaultPaymentsItemModel() : GETLICENSES;
  //   this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty = LICENSES.productQty - 1;
  //   this.newModelLicenses = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0];
  //   this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  //   var ExistingProductQty: number = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].productQty;
  //   var otherchargess: number = parseFloat(((this.finalPaymentReturnModalDisplay.licenseAmount) - (LICENSES.productAmount * ExistingProductQty)).toString());
  //   this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.LICENSES)[0].otherCharges = parseFloat(otherchargess.toFixed(2));
  // }


  calculateMinDate(dateSent: Date) {
    this.currentDate = dateSent.toISOString().split("T")[0];
  }

  getDaysFromDates(oldDate: Date, newDate: Date): number {

    oldDate = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), 0, 0, 0, 0);
    newDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0, 0);
    var differenceInTime = newDate.getTime() - oldDate.getTime();
    var differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;

  }


  changeDate(event) {
    var which = event.which
    if (which === 13 || which === 9) {
      event.target.disabled = true
    }
  }

  getOnInitExpireDate() {

    if (this.parentPaymentModal.firstIsPending) {
      this.currentDate = new Date().toISOString().split("T")[0];
    } else {
      var oldDatee = this.parentPaymentModal.oldValidityDate;
      var oldvalidityDatee = new Date(oldDatee);
      this.currentDate = new Date(oldvalidityDatee).toISOString().split("T")[0];

    }
    var oldDate = this.parentPaymentModal.oldValidityDate;

    if (oldDate == undefined || oldDate == null) {
      this.expireOnDate = new Date();
      this.expireOnDate.setDate(this.expireOnDate.getDate() + 30);
      this.expireOnDate = this.expireOnDate.toISOString().split("T")[0];
      var previous_date = new Date(this.currentDate);
      var new_date = new Date(this.todayDate);
      this.daysDifference = this.getDaysFromDates(previous_date, new_date);
    } else {
      var oldvalidityDate = new Date(oldDate);
      this.expireOnDate = new Date(oldvalidityDate).toISOString().split("T")[0];
    }
  }

  // onSaveViaLinkSetDate() {
  //   var oldDate = this.parentPaymentModal.oldValidityDate;
  //   if (oldDate == undefined || oldDate == null) {
  //     this.expireOnDate = new Date();
  //     this.expireOnDate.setDate(this.expireOnDate.getDate() + 30);
  //     this.expireOnDate = this.expireOnDate.toISOString().split("T")[0];
  //     var previous_date = new Date(this.currentDate);
  //     var new_date = new Date(this.todayDate);
  //     this.daysDifference = this.getDaysFromDates(previous_date, new_date);
  //     this.changeExpire(this.expireOnDate);
  //   } else {
  //     var oldvalidityDate = new Date(oldDate);
  //     var DateExpire = new Date(oldvalidityDate);
  //     DateExpire.setDate(DateExpire.getDate() + 30);
  //     this.expireOnDate = new Date(DateExpire).toISOString().split("T")[0];
  //     this.changeExpire(this.expireOnDate);
  //   }
  // }

  // new payment method applied here -----------------------

  newLicenseCalculations(noOfLicense) {
    this.calculatePendingDays();
    this.pendingLicenseDays = this.calculatePendingDays();
    let licenseAmount: number = this.oneLicenseAmount * noOfLicense;
    this.calculatedLicenseAmount = this.oneLicenseAmount * Number(noOfLicense);
    let actualAmount = Number((this.calculatedLicenseAmount*this.pendingLicenseDays/30).toFixed(2));
    this.actualLicenseAmount = actualAmount;

    let taxAmount = Number((.0625 * actualAmount).toFixed(2));
    this.taxOnLicenseActualAmount = taxAmount;

    let total: number = Number((actualAmount + taxAmount).toFixed(2));
    this.totalLicenseAmountCalculated = total;
    let totalRoundOff = Math.round(total);
    this.roundOffValueLicense = (totalRoundOff - total).toFixed(2);
    this.licenseTotalAmount = Number(totalRoundOff);

  }

  resetLicenseRoundOff() {
    this.roundOffValueLicense = '';
    this.totalLicenseAmountCalculated = 0;
  }

  calculatePendingDays() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    let aDate: string = yyyy + '-' + mm + '-' + dd;
    let oldDate = this.expireOldDate.split('-');

    const startDate: any = (new Date(aDate));
    const endDate: any = (new Date(this.expireOldDate));
    let timeDiff = endDate - startDate;
    const days = timeDiff / (1000 * 60 * 60 * 24)
    if (Math.sign(days) == -1) {
      alert('expired');
      this.licenseEdit = true;
    } else {
      this.licenseEdit = true;
    }
    return Number(days);
  }



  getLicenseRequestNew() {
    this._service.getLicenseRequest(this.adminId).subscribe(
      (data) => {
        this.licenseModelNew = data;
      },
      (error) => {
        this.changeAdmin(this.adminId);
      });
  }

  resetLicenseNew() {
    this.extendLicenseQty = '1';
    this.resetPaymentMethod();

  }

  extendLicenseNew(paymentMethod) {
    if( this.actualLicenseAmount > 0 || this.selectedLicenseType == 1) {
    this.processLicenseRequest = true;
    let newQty = Number(this.extendLicenseQty);
    let paymentType = paymentMethod;
    let ModeNoString;
    let HospitalId = this.adminId;
    let productDetail = this.licenseModelNew;
    let licenseBody: any;
    if (paymentMethod == 2) {
      ModeNoString = this.selectedLicenseType == 1 ? 'NA' :'Payment via Cash';
      licenseBody = {
        newQty: newQty,
        paymentType: paymentType,
        HospitalId: HospitalId,
        ModeNoString: ModeNoString,
        productDetail: productDetail
      }
      this.addNewLicenseRequest(licenseBody);

    } else {
      ModeNoString = this.chequeNumberNew;

      licenseBody = {
        newQty: newQty,
        paymentType: paymentType,
        ModeNoString: ModeNoString,
        HospitalId: HospitalId,
        productDetail: productDetail
      }
      if (this.chequeNumberNew.length < 6 || this.chequeNumberNew.length > 10) {
        this.processLicenseRequest = false;
        AlertMessages.Show('Add 6-10 digits', 'Fill Cheque Number', AlertType.Warning);
      } else {
        this.addNewLicenseRequest(licenseBody);
      }

    }
  } else {
    AlertMessages.Show('Not Allowed','Amount is 0',AlertType.Warning);
  }
  }

  addNewLicenseRequest(licenseData) {
    this._service.extendLicenseRequest(licenseData).subscribe(
      (data) => {
        AlertMessages.Show('Added', data[0], AlertType.Add);
        this.resetLicenseNew();
        this.resetLicenseRoundOff();
        this.newLicenseCalculations(this.extendLicenseQty);
        this.changeAdmin(this.adminId);
      }, (error) => {
        AlertMessages.Show('Failed', 'Could not add License', AlertType.Error);

      }).add(() => {
      this.processLicenseRequest = false;
    })
  }

  choosePaymentMethod(selectedMethod) {
    if (selectedMethod == '2') {
      this.showChequeDetail = false;
    } else {
      this.showChequeDetail = true;
    }

  }

  // validity extension logic ------------------
  getValidityData() {
    this._service.getValidityRequest(this.adminId).subscribe((data) => {
      this.validityModelNew = data;
      this.saveCurrentExpiryDate = this.expireOldDate;

    }, (error) => {
      this.changeAdmin(this.adminId);

    });
  }

  setValidateDate() {
    this.expireOnDate = this.saveCurrentExpiryDate;
  }

  calculateValidityExtension() {
    let perDayAmount = ((this.validityModelNew.LicensePrice * this.validityModelNew.TotalLicense) + this.validityModelNew.BasePrice) / 30;
    if(this.selectedLicenseType == 1) {
      this.resetValidityVars();
    } else {
      this.calculatedValidityAmount = Number((perDayAmount*this.extendValidityDays).toFixed(2));
      let totalAmount = Number((perDayAmount * this.extendValidityDays));
      let taxIs = totalAmount * .0625;
      let taxableAmount = Number(((perDayAmount + taxIs)*this.extendValidityDays).toFixed(2));

      this.calculatedValidityTax = Number(taxIs.toFixed(2));
      this.roundedValidityAmount = Number((this.calculatedValidityAmount + this.calculatedValidityTax).toFixed(2));

      let roundOff =  Math.round(this.roundedValidityAmount);
      this.roundOffValueValidity = (roundOff - this.roundedValidityAmount).toFixed(2);
      this.actualValidityAmount = roundOff;


    }
  }

  calculateValidityDays(expireDate) {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    let aDate: string = yyyy + '-' + mm + '-' + dd;
    let oldDate = expireDate.split('-');
    let calStartDate = new Date(this.expireOldDate) < new Date(aDate) ? new Date(aDate) : this.expireOldDate

    const startDate: any = (new Date(calStartDate));
    const endDate: any = (new Date(oldDate));
    let timeDiff = endDate - startDate;
    const days = Math.round(timeDiff / (1000 * 60 * 60 * 24));
    this.extendValidityDays = Number(days.toFixed(2));
    this.calculateValidityExtension();

    return Number(days);
  }

  extendValidityNew(paymentMethod) {
    if (this.extendValidityDays > 0 ) {
      this.processValidityRequest = true;
      let newQty = Number(this.extendValidityDays);
      let PaymentType = paymentMethod;
      let ModeNoString = this.chequeNumberNew;
      let HospitalId = this.adminId;
      let productDetail = this.validityModelNew;
      let validityBody: any;
      // let margin = 'Round off: '+this.roundOffValueValidity;
      if (paymentMethod == 2) {
        ModeNoString = this.selectedLicenseType == 1 ? 'NA' : 'Payment via cash';
        validityBody = {
          newQty: newQty,
          PaymentType: PaymentType,
          HospitalId: HospitalId,
          ModeNoString: ModeNoString,
          productDetail: productDetail,
        }
        this.addNewValidityRequest(validityBody);

      } else {
        ModeNoString = this.chequeNumberNew;
        validityBody = {
          newQty: newQty,
          PaymentType: PaymentType,
          ModeNoString: ModeNoString,
          HospitalId: HospitalId,
          productDetail: productDetail
        }
        if (this.chequeNumberNew.length < 6 || this.chequeNumberNew.length > 10) {
          this.processValidityRequest = false;
          AlertMessages.Show('Add 6-10 digits', 'Fill Cheque Number', AlertType.Warning);
        } else {
          this.addNewValidityRequest(validityBody);

        }

      }
    } else {
      AlertMessages.Show('Not Allowed', 'Days are not added!', AlertType.Warning);
    }
  }

  addNewValidityRequest(validityData) {
    this._service.extendValidityRequest(validityData).subscribe((data) => {
        AlertMessages.Show('Extended','Expiry date is extended',AlertType.Success);
        this.changeAdmin(this.adminId);
        this.resetValidityNew();
      },
      (error) => {
        AlertMessages.Show('Failed','could not extended',AlertType.Error);

      }).add(() => {
      this.processValidityRequest = false;
    })
  }

  resetValidityNew() {
    this.extendValidityDays = 0;
    this.resetValidityVars();
    this.resetPaymentMethod();
  }

  resetValidityVars() {
    this.actualValidityAmount = 0;
    this.roundOffValueValidity = '';
    this.calculatedValidityAmount = 0;
    this.calculatedValidityTax = 0;
    this.roundedValidityAmount = 0;
  }

  resetPaymentMethod() {
    this.chequeNumberNew = '';
    this.selectedPaymentMethod = '2';
    this.choosePaymentMethod(this.selectedPaymentMethod);
  }

  // first payment logic -------------

  getFirstPaymentStatus() {
    this._service.getPendingPayments(this.adminId).subscribe(
      (data) => {

        this.firstPaymentModel = data;
        this.firstPaymentStatus = this.firstPaymentModel.FirstPending;
        this.saleItemsArray = this.firstPaymentModel.SaleItems;
        if(this.selectedLicenseType != 1){
          if(this.firstPaymentStatus) {
            $('#masterModal').modal('show');

            if(this.firstPaymentModel.SaleItems.length) {
              // let total = 0;
              // for(let i = 0;i < this.firstPaymentModel.SaleItems.length; i++) {
              //   total = this.firstPaymentModel.SaleItems[i].Total + total;
              // }
              // this.firstPaymentTotal = total;
              this.firstPaymentTotal = this.firstPaymentModel.TotalPayable;


            } else {
              this.firstPaymentTotal = '0';
            }
          } else {
            this.getLicenseRequestNew();
            this.getValidityData();
          }

        } else {
          this.getLicenseRequestNew();
          this.getValidityData();
        }

    },
    (error) => {
      AlertMessages.Show('Failed','First Payment details missed',AlertType.Error);
      this.changeAdmin(this.adminId);

    })
  }

  payFirstPayment(paymentMethod) {
      this.processMasterRequest = true;
      let PaymentType = paymentMethod;
      let ModeNoString;
      let HospitalId = this.adminId;
      let PendingPayments = this.firstPaymentModel;
      let masterBody: any;
      if (paymentMethod == 2) {
        ModeNoString = 'first payment via cash';
        masterBody = {
          PaymentType: PaymentType,
          HospitalId: HospitalId,
          ModeNoString: ModeNoString,
          PendingPayments: PendingPayments
        }
        this.makeFirstPaymentRequest(masterBody);

      } else {
        ModeNoString = this.chequeNumberNew;
        masterBody = {
          PaymentType: PaymentType,
          ModeNoString: ModeNoString,
          HospitalId: HospitalId,
          PendingPayments: PendingPayments
        }
        if (this.chequeNumberNew.length < 6 || this.chequeNumberNew.length > 10) {
          this.processMasterRequest = false;
          AlertMessages.Show('Add 6-10 digits', 'Fill Cheque Number', AlertType.Warning);
        } else {
          this.makeFirstPaymentRequest(masterBody);

        }

      }
  }

  makeFirstPaymentRequest(masterData) {
    this._service.doMasterPayment(masterData).subscribe(
    (data) => {
      AlertMessages.Show('Success',data[0],AlertType.Success);
      this.resetPaymentMethod();
      this.firstPaymentStatus = false;
    },
    (error) => {
      AlertMessages.Show('Failed','Could not complete',AlertType.Error)
    }).add(() => {
      this.processMasterRequest = false;
    });
  }

  // upgrade to register ----------

  getDemoLicenseDetails() {
    this.processExtensionRequest = true;
    this.showExtensionPaymentMethod = false;

    this._service.getDemoLicenseDetails(this.adminId).subscribe(
    (data) => {
      this.upgradeLicenseModelNew = data;
      let amountActual = this.upgradeLicenseModelNew.PaidAmount.toFixed(2);
      this.demoToRegActualAmount = amountActual;
      let roundedAmount = Math.round(amountActual);
      let roundedOffValue = (roundedAmount - amountActual).toFixed(2);
      this.roundOffValueDemoToReg = roundedOffValue;
      this.amountForUpgrade = Number(roundedAmount);
    },
    (error) => {
      AlertMessages.Show('Failed','Could not load info',AlertType.Error);
      this.showExtensionPaymentMethod = true;

    }).add(() => {
      this.processExtensionRequest = false;
    })
  }

  checkLicenseUpgrade(paymentMethod) {
    this.processExtensionRequest = true;
    let PaymentType = paymentMethod;
    let ModeNoString;
    let HospitalId = this.adminId;
    let ProductDetail = this.upgradeLicenseModelNew;
    let upgradeBody: any;
    if (paymentMethod == 2) {
      ModeNoString = 'Payment via cash';
      upgradeBody = {
        PaymentType: PaymentType,
        HospitalId: HospitalId,
        ModeNoString: ModeNoString,
        ProductDetail: ProductDetail
      }
      this.upgradeToRegister(upgradeBody);

    } else {
      ModeNoString = this.chequeNumberNew;
      upgradeBody = {
        PaymentType: PaymentType,
        ModeNoString: ModeNoString,
        HospitalId: HospitalId,
        ProductDetail: ProductDetail
      }
      if (this.chequeNumberNew.length < 6 || this.chequeNumberNew.length > 10) {
        this.processExtensionRequest = false;
        AlertMessages.Show('Add 6-10 digits', 'Fill Cheque Number', AlertType.Warning);
      } else {
        this.upgradeToRegister(upgradeBody);

      }

    }

  }

  upgradeToRegister(upgradeData) {
    this._service.getRegisteredLicense(upgradeData).subscribe(
    (data) => {
      AlertMessages.Show('Upgraded',data[0],AlertType.Success);
      this.changeAdmin(this.adminId);
      this.showExtensionPaymentMethod = true;
      this.resetDemoToRegVariables();
      this.goBackLink();
    },
    (error) => {
      AlertMessages.Show('failed','Could not upgrade',AlertType.Error);

    }).add(() => {
      this.processExtensionRequest = false;
    });

  }

  resetDemoToRegVariables() {
    this.amountForUpgrade = 0;
    this.demoToRegActualAmount = 0;
    this.roundOffValueDemoToReg = '';
  }


  // -------------------------------------------

  // changeExpire(expireDate) {
  //   var oldDate = this.parentPaymentModal.oldValidityDate;
  //   var diff: number = 0;
  //   if (oldDate == undefined || oldDate == null) {
  //     var TodayDate = new Date();
  //     var changedDate = new Date(expireDate);
  //     diff = this.getDaysFromDates(TodayDate, changedDate);
  //   } else {
  //     var oldDateeee = new Date(oldDate).toISOString().split("T")[0];
  //     var OldDate_1: Date = new Date(oldDate);
  //     var changedDate = new Date(expireDate);
  //     diff = this.getDaysFromDates(OldDate_1, changedDate);
  //   }

  //   var NewModel: PaymentsItemModel[] = this.parentPaymentModal.newModel;
  //   var OldModel: PaymentsItemModel[] = this.parentPaymentModal.oldModel;


  //   if (NewModel.length < 1) {
  //     this.updateValidityCount(1, NewModel);
  //   } else {
  //     if (NewModel.filter(model => model.productType == EProductType.VALIDITY).length < 1) {
  //       this.updateValidityCount(1, NewModel);
  //     } else {
  //       this.updateValidityCount(0, NewModel);
  //     }
  //   }

  //   this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0].productQty = diff;
  //   this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  // }

  //0 For New and 1 For Old
  // updateValidityCount(validityType: number, newModel: PaymentsItemModel[]) {
  //   if (validityType == 1) {
  //     var GETVALIDITY: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.VALIDITY)[0];
  //     var VALIDITY: PaymentsItemModel = this.getDefaultPaymentsItemModel1(EProductType.VALIDITY);
  //     if (VALIDITY != null && VALIDITY != undefined) {
  //       if (VALIDITY.productId != null && VALIDITY.productId != undefined && VALIDITY.productId != "") {
  //         this.parentPaymentModal.newModel.push(VALIDITY);
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0].productQty = VALIDITY.productQty + 1;

  //         this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  //       } else {
  //         VALIDITY = this.getDefaultPaymentsItemModel();
  //         AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);
  //       }

  //     } else {
  //       VALIDITY = this.getDefaultPaymentsItemModel();
  //       AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);
  //     }
  //   } else {
  //     var GETVALIDITY: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.VALIDITY)[0];
  //     var VALIDITY: PaymentsItemModel = GETVALIDITY == undefined || GETVALIDITY == null ? this.getDefaultPaymentsItemModel1(EProductType.VALIDITY) : GETVALIDITY;
  //     if (VALIDITY != null && VALIDITY != undefined) {
  //       if (VALIDITY.productId != null && VALIDITY.productId != undefined && VALIDITY.productId != "") {
  //         this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0].productQty = VALIDITY.productQty + 1;

  //         this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  //       } else {
  //         VALIDITY = this.getDefaultPaymentsItemModel();
  //         AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);

  //       }
  //     } else {
  //       VALIDITY = this.getDefaultPaymentsItemModel();
  //       AlertMessages.Show("Warning", 'License Information Is Not Available', AlertType.Warning);
  //     }
  //   }
  // }

  getDefaultPaymentsItemModel(): PaymentsItemModel {

    var PaymentsItemModel1: PaymentsItemModel = new PaymentsItemModel();
    PaymentsItemModel1.productId = "";
    PaymentsItemModel1.productName = "";
    PaymentsItemModel1.productType = null;
    PaymentsItemModel1.productQty = 0;
    PaymentsItemModel1.productAmount = 0;
    PaymentsItemModel1.isChecked = false;
    PaymentsItemModel1.notes = "";
    PaymentsItemModel1.saleProducts = [];
    PaymentsItemModel1.otherCharges = 0;
    return PaymentsItemModel1;

  }

  // getDefaultPaymentsItemModel1(productType: EProductType): PaymentsItemModel {

  //   var PaymentsItemModel1: PaymentsItemModel = new PaymentsItemModel();
  //   switch (productType) {
  //     case EProductType.MASTER:
  //       PaymentsItemModel1.productId = "";
  //       PaymentsItemModel1.productName = "";
  //       PaymentsItemModel1.productType = null;
  //       PaymentsItemModel1.productQty = 0;
  //       PaymentsItemModel1.productAmount = 0;
  //       PaymentsItemModel1.isChecked = false;
  //       PaymentsItemModel1.notes = "";
  //       PaymentsItemModel1.saleProducts = [];
  //       PaymentsItemModel1.otherCharges = 0;
  //       return PaymentsItemModel1;
  //     case EProductType.LICENSES:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.LICENSES)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = nLicense.productId;
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //         // PaymentsItemModel1 = this.assignModel(nLicense);
  //       }
  //       return PaymentsItemModel1;

  //     case EProductType.OTHERS:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.OTHERS)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = nLicense.productId;
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //       }
  //       return PaymentsItemModel1;

  //     case EProductType.SERVICES:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.SERVICES)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = nLicense.productId;
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //       }
  //       return PaymentsItemModel1;

  //     case EProductType.VALIDITY:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.VALIDITY)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = nLicense.productId;
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //       }
  //       return PaymentsItemModel1;
  //     case EProductType.DEMO:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.DEMO)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = "";
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //       }
  //       return PaymentsItemModel1;
  //     case EProductType.CHANGE:
  //       var nLicense: ProductsDetail1 = this.parentPaymentModal.allProducts.filter(product => product.productType == EProductType.CHANGE)[0];
  //       if (nLicense != null && nLicense != undefined) {
  //         PaymentsItemModel1.productId = "";
  //         PaymentsItemModel1.productName = nLicense.productName;
  //         PaymentsItemModel1.productType = nLicense.productType;
  //         PaymentsItemModel1.productQty = 0;
  //         PaymentsItemModel1.productAmount = nLicense.amount;
  //         PaymentsItemModel1.isChecked = true;
  //         PaymentsItemModel1.notes = "";
  //         PaymentsItemModel1.saleProducts = [];
  //         PaymentsItemModel1.otherCharges = 0;
  //       }
  //       return PaymentsItemModel1;
  //   }
  // }

  // getDefaultPaymentsItemModel1Services(productId: string, productName: string, productAmount: number): PaymentsItemModel {

  //   var PaymentsItemModel1: PaymentsItemModel = new PaymentsItemModel();
  //   PaymentsItemModel1.productId = productId;
  //   PaymentsItemModel1.productName = productName;
  //   PaymentsItemModel1.productType = EProductType.SERVICES;
  //   PaymentsItemModel1.productQty = 1;
  //   PaymentsItemModel1.productAmount = productAmount;
  //   PaymentsItemModel1.isChecked = true;
  //   PaymentsItemModel1.notes = "";
  //   PaymentsItemModel1.saleProducts = [];
  //   PaymentsItemModel1.otherCharges = 0;
  //   return PaymentsItemModel1;

  // }

  // changeServices(event, selectedProduct: ProductsDetail1) {
  //   if (event.target.checked == true) {

  //     var AddedProDetail: PaymentsItemModel = this.getDefaultPaymentsItemModel1Services(selectedProduct.productId, selectedProduct.productName, selectedProduct.amount);
  //     if (AddedProDetail != null && AddedProDetail != undefined) {
  //       if (AddedProDetail.productId != null && AddedProDetail.productId != "") {
  //         this.parentPaymentModal.newModel.push(AddedProDetail);
  //       }
  //     }
  //   } else {

  //     var selectedProDetail: PaymentsItemModel = this.parentPaymentModal.newModel.filter(model => model.productId == selectedProduct.productId)[0];
  //     if (selectedProDetail != null && selectedProDetail != undefined) {
  //       if (selectedProDetail.productId != null && selectedProDetail.productId != "") {
  //         var selectedProIndex: number = this.parentPaymentModal.newModel.indexOf(selectedProDetail);
  //         this.parentPaymentModal.newModel.splice(selectedProIndex, 1);
  //       }
  //     }
  //   }

  //   this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);

  // }

  // Payment Methods
  paymentUpdation(paymentUpdationModal: PaymentParentModel): LicensesFinalPaymentModal {

    this.licenseData = new PaymentsItemModel();
    var newModel: PaymentsItemModel[] = paymentUpdationModal.newModel;
    var oldModel: PaymentsItemModel[] = paymentUpdationModal.oldModel;
    if (paymentUpdationModal.firstIsPending) {
      this.currentDate = new Date().toISOString().split("T")[0];
    } else {
      this.currentDate = new Date(paymentUpdationModal.oldValidityDate).toISOString().split("T")[0];
    }

    //Get Records from the New List
    var FinalPaymentReturnModal: LicensesFinalPaymentModal = new LicensesFinalPaymentModal();
    var GETLICENSES: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.LICENSES)[0];
    var LICENSES: PaymentsItemModel = GETLICENSES == undefined || GETLICENSES == null ? this.getDefaultPaymentsItemModel() : GETLICENSES;
    this.newModelLicenses = LICENSES;
    var GETVALIDITY: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.VALIDITY)[0];
    var VALIDITY: PaymentsItemModel = GETVALIDITY == undefined || GETVALIDITY == null ? this.getDefaultPaymentsItemModel() : GETVALIDITY;
    var GETMASTER: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.MASTER)[0];
    var MASTER: PaymentsItemModel = GETMASTER == undefined || GETMASTER == null ? this.getDefaultPaymentsItemModel() : GETMASTER;
    var GETOTHERS: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.OTHERS)[0];
    var OTHERS: PaymentsItemModel = GETOTHERS == undefined || GETOTHERS == null ? this.getDefaultPaymentsItemModel() : GETOTHERS;
    var GETSERVICES: PaymentsItemModel[] = newModel.filter(model => model.productType == EProductType.SERVICES);
    var UPDATIONProd: PaymentsItemModel = newModel.filter(model => model.productType == EProductType.DEMO || model.productType == EProductType.CHANGE)[0];
    // var SERVICES: PaymentsItemModel = GETSERVICES == undefined || GETSERVICES == null ? this.GetDefaultPaymentsItemModel() : GETSERVICES;
    this.updationProduct = UPDATIONProd == undefined || UPDATIONProd == null ? this.getDefaultPaymentsItemModel() : UPDATIONProd;

    //Get Records from the Old List
    var GETLICENSES_OLD: PaymentsItemModel = oldModel.filter(model => model.productType == EProductType.LICENSES)[0];
    var LICENSES_OLD: PaymentsItemModel = GETLICENSES_OLD == undefined || GETLICENSES_OLD == null ? this.getDefaultPaymentsItemModel() : GETLICENSES_OLD;
    this.oldModelLicenses = LICENSES_OLD;
    var GETVALIDITY_OLD: PaymentsItemModel = oldModel.filter(model => model.productType == EProductType.VALIDITY)[0];
    var VALIDITY_OLD: PaymentsItemModel = GETVALIDITY_OLD == undefined || GETVALIDITY_OLD == null ? this.getDefaultPaymentsItemModel() : GETVALIDITY_OLD;
    var GETMASTER_OLD: PaymentsItemModel = oldModel.filter(model => model.productType == EProductType.MASTER)[0];
    var MASTER_OLD: PaymentsItemModel = GETMASTER_OLD == undefined || GETMASTER_OLD == null ? this.getDefaultPaymentsItemModel() : GETMASTER_OLD;
    var GETOTHERS_OLD: PaymentsItemModel = oldModel.filter(model => model.productType == EProductType.OTHERS)[0];
    var OTHERS_OLD: PaymentsItemModel = GETOTHERS_OLD == undefined || GETOTHERS_OLD == null ? this.getDefaultPaymentsItemModel() : GETOTHERS_OLD;
    var GETSERVICES_OLD: PaymentsItemModel[] = oldModel.filter(model => model.productType == EProductType.SERVICES);
    var newLiccCount: number = LICENSES.productQty;
    this.newLicCount = newLiccCount;
    var totalLicenseQty: number = LICENSES.productQty + LICENSES_OLD.productQty;
    this.totalLicensesCount = 0;
    this.totalLicensesCount = totalLicenseQty;
    this.masterCostt = MASTER.productAmount;
    var accesstype = MASTER.accessType;
    this.accessTypeMain = accesstype;
    if (accesstype == 1) {
      this.masterType = "Full Accesss"
    } else {
      this.masterType = "Partial Accesss"
    }

    //Calculate Payment if the User is New OR First Time Payment (Then we will not calculate Old Records)
    if (paymentUpdationModal.firstIsPending) {

      FinalPaymentReturnModal = new LicensesFinalPaymentModal();
      var LicenseAmount: number = LICENSES.productAmount * LICENSES.productQty;
      var LicenseNotes: string = "";
      // var ValidityAmount: number = (((LICENSES.productAmount / 30) * VALIDITY.productQty) * LICENSES.productQty);
      var ValidityAmount: number = (((LICENSES.productAmount * LICENSES.productQty) + 100) / 30) * VALIDITY.productQty;

      var ValidityDays = VALIDITY.productQty;
      var ValidityNotes: string = "Formulla: ((LicenseAmount (" + LICENSES.productAmount.toFixed(2) + ") / 30 (DAYS)) * Validity For " + VALIDITY.productQty + " (Days)) * No. Of Licenses Buy (" + LICENSES.productQty + ") = " + ValidityAmount.toFixed(2) + "";
      var serviceAmt: number = 0.00;
      if (GETSERVICES != null && GETSERVICES.length > 0) {
        GETSERVICES.forEach(x => serviceAmt += (x.productAmount * x.productQty));
      }

      var ServicesAmount: number = serviceAmt;
      var ServicesNotes: string = "";
      var ValidityFinalAmount: number = (ValidityAmount - LicenseAmount);
      var ValidityFinalNote: string = ""
      var LicenseFinalAmount: number = (ValidityFinalAmount + LicenseAmount);
      var LicenseFinalNotes: string = "";
      var SubTotal: number = LicenseFinalAmount + (OTHERS.productAmount * OTHERS.productQty) + (ServicesAmount);
      var Tax: number = (SubTotal * 6.25) / 100;
      var TotalAmount: number = (SubTotal + Tax);
      var FinalNotes: string = "Final amount calculation for this plan : " + " Per license amount = $" + LICENSES.productAmount.toFixed(2) + " , Qty : " + LICENSES.productQty + " " + "<br/> 1).<b> Validity adjustment for " + ValidityDays + " days </b> : $" + ValidityAmount.toFixed(2) + " ( \'For first time payment , validity is free for 30 Days\' ) " + "<br/>2). <b>Service Amount</b> : $" + ServicesAmount + " , 3). <b>Web Panel </b>: $" + (MASTER.productAmount * MASTER.productQty) + " , 4).<b> Tax (6.25) </b>: $" + Tax.toFixed(2) + "<br/> <b>Total Amount</b> ( Validity Adjustment+Web Panel Amount+Service Amount+Tax ) : $" + TotalAmount.toFixed(2);

      FinalPaymentReturnModal.singleLicenseCost = this.newModelLicenses.productAmount;
      FinalPaymentReturnModal.licenseAmount = LicenseAmount;
      FinalPaymentReturnModal.licenseNotes = LicenseNotes;
      FinalPaymentReturnModal.validityAmount = ValidityAmount;
      FinalPaymentReturnModal.validityNotes = ValidityNotes;
      FinalPaymentReturnModal.servicesAmount = ServicesAmount;
      FinalPaymentReturnModal.servicesNotes = ServicesNotes;
      FinalPaymentReturnModal.validityFinalAmount = ValidityFinalAmount;
      FinalPaymentReturnModal.validityFinalNote = ValidityFinalNote;

      FinalPaymentReturnModal.subTotal = SubTotal;
      FinalPaymentReturnModal.tax = Tax;
      FinalPaymentReturnModal.totalAmount = TotalAmount;
      FinalPaymentReturnModal.finalNotes = FinalNotes;
      FinalPaymentReturnModal.validityDays = ValidityDays;
      this.totalAmountI = parseFloat(FinalPaymentReturnModal.totalAmount.toFixed(2));
      this.taxAmount = parseFloat(FinalPaymentReturnModal.tax.toFixed(2));
      this.subTotalAmount = parseFloat(FinalPaymentReturnModal.subTotal.toFixed(2));

    } else {
      // Calculate Results Old and New List

      FinalPaymentReturnModal = new LicensesFinalPaymentModal();
      var ValidityDays: number = 0;
      ValidityDays = VALIDITY.productQty;
      var LicenseAmount_New: number = LICENSES.productAmount * LICENSES.productQty;
      var LicenseNotes_New: string = "";
      var OldValidityPending: number = this.getDaysFromDates(new Date(), new Date(this.parentPaymentModal.oldValidityDate));

      //Find the amount for the new license for pending valid days
      var LicenseFinalAmount_AccNewLic: number = (((((LICENSES.productAmount / 30) * OldValidityPending) * LICENSES.productQty) - LICENSES.productAmount) + LICENSES.productAmount);

      //Now Create a validity Amount

      // 1. Find the License Amount For Added Days
      var amountForNewDays = (((LICENSES.productAmount / 30) * VALIDITY.productQty) * (LICENSES.productQty + LICENSES_OLD.productQty));
      var getAmountForMasterLicense = ((MASTER_OLD.productAmount / 30) * VALIDITY.productQty);

      //calculate new license with old days left amount
      var NewLicenseAmountWithPendingOldDays: number = (((LICENSES.productAmount / 30) * (OldValidityPending)) * (LICENSES.productQty));
      var serviceAmt: number = 0.00;

      if (GETSERVICES != null && GETSERVICES.length > 0) {
        GETSERVICES.forEach(x => serviceAmt += (x.productAmount * x.productQty));
      }


      var getServicesAmount = ((serviceAmt / 30) * (VALIDITY.productQty));
      var getTotalValidityAmount = amountForNewDays + getAmountForMasterLicense + getServicesAmount + NewLicenseAmountWithPendingOldDays;
      var LicenseFinalAmount: number = 0;
      var OLD_MASTER_COST: number = (((MASTER_OLD.productAmount / 30) * MASTER_OLD.productQty * ValidityDays));
      var OLD_LICENSE_COST: number = (((LICENSES_OLD.productAmount / 30) * LICENSES_OLD.productQty * ValidityDays));
      var OLD_OTHER_COST: number = (((OTHERS_OLD.productAmount / 30) * OTHERS_OLD.productQty * ValidityDays));
      var serviceAmt_OLD: number = 0.00;

      if (GETSERVICES_OLD != null && GETSERVICES_OLD.length > 0) {
        GETSERVICES_OLD.forEach(x => serviceAmt_OLD += (x.productAmount * x.productQty));
      }

      var OLD_SERVICES_COST: number = (((serviceAmt_OLD / 30) * ValidityDays));

      //OldValidityPending
      var NEW_MASTER_COST: number = (((((MASTER.productAmount) / 30) * MASTER.productQty) * ValidityDays));
      var NEW_LICENSE_COST: number = (((((LICENSES.productAmount) / 30) * LICENSES.productQty) * ValidityDays));
      var NEW_VALIDITY_SETTLEMENT_COST: number = ((((LICENSES.productAmount) / 30) * LICENSES.productQty) * OldValidityPending);
      var NEW_OTHER_AMOUNT_COST: number = (MASTER.productAmount * MASTER.productQty);
      var serviceAmt_NEW: number = 0.00;

      if (GETSERVICES != null && GETSERVICES.length > 0) {
        GETSERVICES.forEach(x => serviceAmt_NEW += (x.productAmount * x.productQty));
      }

      var NEW_SERVICES_COST: number = (serviceAmt_NEW);
      var NewChangeProductCost = this.updationProduct.productAmount;
      var SubTotal: number = 0;
      SubTotal = OLD_MASTER_COST + OLD_LICENSE_COST + OLD_OTHER_COST + OLD_SERVICES_COST + NEW_MASTER_COST + NEW_LICENSE_COST + NEW_VALIDITY_SETTLEMENT_COST + NEW_SERVICES_COST + NEW_OTHER_AMOUNT_COST + NewChangeProductCost;

      var Tax: number = (SubTotal * 6.25) / 100;
      var TotalAmount: number = (SubTotal + Tax);
      var FinalNotes: string = "Final amount calculation for this plan :" + "<br><b>1). Extended license amount</b> ((((New license Amount) / 30) * New license quantity) * Old validity pending days) = $" + NEW_VALIDITY_SETTLEMENT_COST.toFixed(2) + "<br/><b>2). Validity adjustment for " + ValidityDays + " days </b>: $" + ((OLD_LICENSE_COST + NEW_LICENSE_COST + OLD_OTHER_COST) + (OLD_SERVICES_COST + OLD_MASTER_COST)).toFixed(2) + " (Old license cost + New license cost + Old other cost  + Old service cost + Old web panel cost) " + "<br><b>3). Services amount </b>: $" + (NEW_SERVICES_COST).toFixed(2) + "<b>, Tax </b>: $" + Tax.toFixed(2) + "<b> , Web panel  </b>: $" + NEW_MASTER_COST.toFixed(2) + "<br><b>Total Amount </b> (Extended license amount + Validity adjustment amount + Service amount + Web panel amount + Tax) : $" + TotalAmount.toFixed(2);
      FinalPaymentReturnModal.singleLicenseCost = this.newModelLicenses.productAmount;
      FinalPaymentReturnModal.licenseAmount = NEW_VALIDITY_SETTLEMENT_COST;
      FinalPaymentReturnModal.licenseNotes = LicenseNotes_New;
      FinalPaymentReturnModal.validityAmount = ((OLD_LICENSE_COST + NEW_LICENSE_COST + OLD_OTHER_COST) + (OLD_SERVICES_COST + OLD_MASTER_COST));
      FinalPaymentReturnModal.validityNotes = ValidityNotes;
      FinalPaymentReturnModal.servicesAmount = NEW_SERVICES_COST;
      FinalPaymentReturnModal.servicesNotes = ServicesNotes;
      FinalPaymentReturnModal.validityFinalAmount = NEW_VALIDITY_SETTLEMENT_COST;
      FinalPaymentReturnModal.validityFinalNote = ValidityFinalNote;
      FinalPaymentReturnModal.subTotal = SubTotal;
      FinalPaymentReturnModal.tax = Tax;
      FinalPaymentReturnModal.totalAmount = TotalAmount;
      FinalPaymentReturnModal.finalNotes = FinalNotes;
      FinalPaymentReturnModal.validityDays = ValidityDays;
      this.totalAmountI = parseFloat(FinalPaymentReturnModal.totalAmount.toFixed(2));
      this.taxAmount = parseFloat(FinalPaymentReturnModal.tax.toFixed(2));
      this.subTotalAmount = parseFloat(FinalPaymentReturnModal.subTotal.toFixed(2));

      if ((this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0] == null) || (this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0] == undefined)) {} else {
        this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.VALIDITY)[0].productAmount = FinalPaymentReturnModal.validityAmount;
      }
    }
    return FinalPaymentReturnModal;
  }

  // onPaymentTypeChange(index) {
  //   this.activeElement2 = index;
  //   if (this.activeElement2 == 3) {
  //     this.paymentMethodSelected = PaymentMethod.CHEQUE;
  //   }
  //   if (this.activeElement2 == 2) {
  //     this.paymentMethodSelected = PaymentMethod.CASH;
  //   }
  //   if (this.activeElement2 == 4) {
  //     this.paymentMethodSelected = PaymentMethod.LINK;
  //   }
  //   if (this.activeElement2 == PaymentMethod.CHEQUE) {
  //     this.chequeSelected = true;
  //   } else {

  //     this.chequeSelected = false;
  //     this.subTotalAmount = parseFloat(this.finalPaymentReturnModalDisplay.subTotal.toFixed(2));
  //     this.taxAmount = (this.subTotalAmount * 6.25) / 100;
  //     this.taxAmount = parseFloat(this.taxAmount.toFixed(2));
  //     this.discountAmountVal = 0;
  //     this.discountAmountVal = parseFloat(this.discountAmountVal.toFixed(2));
  //     this.totalAmountI = ((parseFloat(this.subTotalAmount.toFixed(2)) + parseFloat(this.taxAmount.toFixed(2))) - parseFloat(this.discountAmountVal.toFixed(2)));

  //   }

  // }

  // paymentSave(form) {
  //   var totalCalculatedAmount: number = this.finalPaymentReturnModalDisplay.totalAmount;
  //   if (this.paymentMethodSelected == PaymentMethod.LINK) {
  //     var daysValidity: number = this.finalPaymentReturnModalDisplay.validityDays;
  //     if (daysValidity == 30) {
  //       this.savePayment(form);
  //     } else {
  //       var alertconfirmPayment = confirm("Payment by link is allowed with 30 days validity only.Do you want to auto update?");
  //       if (alertconfirmPayment == true) {
  //         this.onSaveViaLinkSetDate();
  //       }
  //     }
  //   } else {
  //     if (totalCalculatedAmount > 0) {
  //       if (this.parentPaymentModal.firstIsPending) {
  //         if (this.finalPaymentReturnModalDisplay.validityDays > 0) {
  //           this.savePayment(form);
  //         } else {
  //           AlertMessages.Show("Warning", 'Atleast 1 day validity is required', AlertType.Warning);
  //         }
  //       } else {
  //         this.savePayment(form);
  //       }

  //     } else {
  //       AlertMessages.Show("Warning", 'No changes done', AlertType.Warning);
  //     }
  //   }
  // }

  // savePayment(form) {
  //   let printContents, popupWin;
  //   var dataa: HTMLElement;
  //   printContents = document.getElementById('pdfdataTosend').innerHTML;
  //   var InvoiceHtmlContent = "<html><head></head><body >" + printContents + "</body></html>";
  //   this.finalPaymentDetails = new ProductPaymentDetailsModal();
  //   this.showOverlayPayment = true;
  //   this.finalPaymentDetails.subTotal = form.value.amountControl == null ? 0 : form.value.amountControl == undefined ? 0 : form.value.amountControl;
  //   this.finalPaymentDetails.taxAmount = form.value.taxAmount == null ? 0 : form.value.taxAmount == undefined ? 0 : form.value.taxAmount;
  //   this.finalPaymentDetails.discount = form.value.discountAmountt == null ? 0 : form.value.discountAmountt == undefined ? 0 : form.value.discountAmountt;
  //   this.finalPaymentDetails.totalAmount = form.value.totalAmounttt == null ? 0 : form.value.totalAmounttt == undefined ? 0 : form.value.totalAmounttt;
  //   var totalFormAmount: number = this.finalPaymentDetails.totalAmount;
  //   var totalCalculatedAmount: number = this.finalPaymentReturnModalDisplay.totalAmount;

  //   var subtot: number = this.finalPaymentDetails.subTotal;

  //   if (totalFormAmount > totalCalculatedAmount) {

  //     var GETOTHERS: PaymentsItemModel = this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.OTHERS)[0];
  //     var OTHERS: PaymentsItemModel = GETOTHERS == undefined || GETOTHERS == null ? this.getDefaultPaymentsItemModel1(EProductType.OTHERS) : GETOTHERS;
  //     this.parentPaymentModal.newModel.push(OTHERS);
  //     var otherCharges: number = 0;


  //     otherCharges = parseFloat((totalFormAmount - totalCalculatedAmount).toFixed(2));
  //     if (otherCharges >= 1) {
  //       this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.OTHERS)[0].productAmount = otherCharges;
  //     } else {
  //       this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.OTHERS)[0].productAmount = 0;
  //     }
  //     this.parentPaymentModal.newModel.filter(model => model.productType == EProductType.OTHERS)[0].productQty = 1;
  //   }


  //   this.finalPaymentDetails.paymentMethod = this.paymentMethodSelected;
  //   this.finalPaymentDetails.bankAddress = form.value.bankAddresss == null ? '' : form.value.bankAddresss == undefined ? '' : form.value.bankAddresss;
  //   this.finalPaymentDetails.bankName = form.value.banName == null ? '' : form.value.banName == undefined ? '' : form.value.banName;
  //   this.finalPaymentDetails.chequeNo = form.value.chequeNumber == null ? '' : form.value.chequeNumber == undefined ? '' : form.value.chequeNumber;
  //   this.finalPaymentDetails.nameOnCheque = form.value.NameOnChk == null ? '' : form.value.NameOnChk == undefined ? '' : form.value.NameOnChk;
  //   this.finalPaymentDetails.notes = form.value.noteAddition == null ? '' : form.value.noteAddition == undefined ? '' : form.value.noteAddition;


  //   const saPaymentModel:SaPaymentModel = new SaPaymentModel(this.parentPaymentModal,this.finalPaymentDetails,this.adminId,InvoiceHtmlContent);
  //   this._service.paymentCreationSa(saPaymentModel).subscribe(
  //   (data: any) => {

  //       AlertMessages.Show("Success", 'Succeeded!!!!', AlertType.Success);
  //       form.reset();
  //       this.changeAdmin(this.adminId);
  //       this.subTotalAmount = 0;
  //       this.taxAmount = 0;
  //       this.discountAmountVal = 0;
  //       this.totalAmountI = 0;
  //       this.chequeSelected = true;
  //       this.activeElement2 = PaymentMethod.CHEQUE;
  //       this.paymentModuleStatus = false;

  //   },
  //   (error) => {
  //     AlertMessages.Show("Failed", 'Could not perform!', AlertType.Error);
  //   }).add(() => {
  //     this.showOverlayPayment = false;
  //   });
  // }

  // demoValiditySave(form) {

  //   var dt = form.value.expiryUpDemo;
  //   this.showOverlayPayment = true;
  //   this._service.extendDemoLicenseExpiryDate(this.adminId, dt).subscribe(
  //     (data: string) => {

  //       AlertMessages.Show("Success", data, AlertType.Success);
  //       form.reset();
  //       this.changeAdmin(this.adminId);
  //     },
  //     (error) => {
  //       AlertMessages.Show("Failed", "Could Not save!", AlertType.Error);

  //     }).add(() => {
  //     this.showOverlayPayment = false;
  //   });

  // }

  getInvoice(value) {
    this.invoiceDetailsGetHtml = null;
    this.showAdminListsLoadOne = true;
    this._service.getSingleInvoiceInHtml(value.invoiceNo, value.saId).subscribe(
      (data) => {
        this.invoiceDetailsGetHtml = data;
        var newWindow = window.open("", "newWindow", "resizable=yes");
        if (!!newWindow) {
          newWindow.document.write(this.invoiceDetailsGetHtml);
          newWindow.document.close();
        } else {
          AlertMessages.Show('Print Info', 'Make sure pop-up is allowed', AlertType.Warning);
        }
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not get Invoice!', AlertType.Error);

      }).add(() => {
        this.showAdminListsLoadOne = false;
      });
  }

  upgradeModel(saId) {

    AlertMessages.Show('Unavailable', 'Feature not available yet', AlertType.Warning)
    // This working is under implementation..
    // this.upgradeProducts = [];
    // this._service.getProductsToUpgradeOrDowngrade(saId).subscribe(
    // (data) => {
    //   if (data["Id"] == 1) {
    //     this.upgradeProducts = data["Data"];
    //   } else if (data["Id"] == 0) {
    //     AlertMessages.Show('Warning', data["message"], AlertType.Warning);
    //   }
    // },
    // (error) => {
    //   AlertMessages.Show('Failed', 'Could not perform action!', AlertType.Error);

    // });
  }

  closeUpgradeModel() {
    this.upgradeModelShow = false;

  }


  // upgradeProductSelected(productId: string) {

  //   if (productId != null && productId != undefined && productId != '') {
  //     var product: UpgradeProductModel = this.upgradeProducts.filter(i => i.id == productId)[0];

  //     if (this.parentPaymentModal.newModel.filter(i => i.productType == EProductType.DEMO || i.productType == EProductType.CHANGE).length < 1) {

  //       var PreviousLicensesPayment = this.adminUsers.length * 199;
  //       var FinalPayment = 0;
  //       if (product.productType == EProductType.DEMO) {
  //         FinalPayment = product.amount + PreviousLicensesPayment;
  //       } else {
  //         FinalPayment = product.amount;
  //       }
  //       var updateProduct: PaymentsItemModel = new PaymentsItemModel();
  //       updateProduct.productId = product.id;
  //       updateProduct.productName = product.name;
  //       updateProduct.productType = product.productType;
  //       updateProduct.productQty = 1;
  //       updateProduct.productAmount = FinalPayment;
  //       updateProduct.isChecked = false;
  //       updateProduct.notes = "";
  //       updateProduct.saleProducts = [];
  //       updateProduct.otherCharges = 0;
  //       this.parentPaymentModal.newModel.push(updateProduct);
  //       this.upgradeProducts.filter(i => i.id == product.id)[0].isSelected = true;
  //     } else {
  //       this.parentPaymentModal.newModel = this.parentPaymentModal.newModel.filter(i => i.productType != EProductType.DEMO && i.productType != EProductType.CHANGE);
  //       for (const val of this.upgradeProducts) {
  //         val.isSelected = false;
  //       }
  //     }

  //   } else {
  //     this.parentPaymentModal.newModel = this.parentPaymentModal.newModel.filter(i => i.productType != EProductType.DEMO && i.productType != EProductType.CHANGE);
  //     for (const val of this.upgradeProducts) {
  //       val.isSelected = false;
  //     }
  //   }
  //   this.finalPaymentReturnModalDisplay = this.paymentUpdation(this.parentPaymentModal);
  // }

  // New functions added here on----------------
  // assignModel(license) {
  //   let paymentModel: PaymentsItemModel = new PaymentsItemModel();
  //   paymentModel.productId = license.productId;
  //   paymentModel.productName = license.productName;
  //   paymentModel.productType = license.productType;
  //   paymentModel.productQty = 0;
  //   paymentModel.productAmount = license.amount;
  //   paymentModel.isChecked = true;
  //   paymentModel.notes = "";
  //   paymentModel.saleProducts = [];
  //   paymentModel.otherCharges = 0;

  //   return paymentModel;

  // }











}
